import { saveAs } from 'file-saver';

import { handleError } from '../handleError';

type Unsubscribe = () => void;

export function subscribeBeforeUnload(message: string): Unsubscribe {
  const handler = (event: BeforeUnloadEvent) => {
    event.preventDefault();
    event.returnValue = message; // Для старых браузеров
    return message;
  };

  window.addEventListener('beforeunload', handler);

  // Возвращаем функцию отписки
  return () => {
    window.removeEventListener('beforeunload', handler);
  };
}

export async function downloadElementAsPDF(
  element: HTMLElement,
  fileName = 'element.pdf'
) {
  // Импортируем html2canvas динамически, чтобы не качать его, пока не пригодится
  const { default: html2canvas } = await import('html2canvas');
  const { PDFDocument } = await import('pdf-lib');

  element.style.padding = '16px';

  // Рендерим DOM в canvas
  const canvas = await html2canvas(element, { scale: 1 });
  const image = canvas.toDataURL('image/png');

  element.style.padding = '';

  // Создаём PDF
  const pdfDoc = await PDFDocument.create();
  const page = pdfDoc.addPage([canvas.width, canvas.height]);
  const pngImage = await pdfDoc.embedPng(image);

  // Вставляем на страницу
  page.drawImage(pngImage, {
    x: 0,
    y: 0,
    width: canvas.width,
    height: canvas.height
  });

  // Скачиваем
  const pdfBytes = await pdfDoc.save();
  const blob = new Blob([new Uint8Array(pdfBytes)], {
    type: 'application/pdf'
  });
  saveAs(blob, fileName);
}

export const safeLocalStorage = {
  get: (key: string): string | null => {
    try {
      return typeof window !== 'undefined' ? localStorage.getItem(key) : null;
    } catch {
      return null;
    }
  },
  set: (key: string, value: string): void => {
    try {
      if (typeof window !== 'undefined') localStorage.setItem(key, value);
    } catch (error) {
      handleError(error, {
        notify: false,
        customTitle: 'Не удалось сохранить данные в localStorage'
      });
    }
  },
  remove: (key: string): void => {
    try {
      if (typeof window !== 'undefined') localStorage.removeItem(key);
    } catch (error) {
      handleError(error, {
        notify: false,
        customTitle: 'Не удалось удалить данные из localStorage'
      });
    }
  }
};
